import { render } from "./mediaElement.vue?vue&type=template&id=d808ad42"
import script from "./mediaElement.vue?vue&type=script&lang=js"
export * from "./mediaElement.vue?vue&type=script&lang=js"

import "./mediaElement.vue?vue&type=style&index=0&id=d808ad42&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__